module.exports = __webpack_public_path__ + "img/import.13dec51e.svg";